/* eslint-disable prefer-promise-reject-errors */
import React, { useCallback, useState } from 'react'
import { connect } from 'dva'
import { Row, Col, Form, Input, Button, Upload, message } from 'antd'
import PageWrapper from '@/components/PageWrapper'
import './Info.module.less'

const layout = {
  labelCol: { span: 3 },
  // wrapperCol: { span: 21 },
}

const BaseInfo = ({ dispatch, baseInfo, editBaseInfo }) => {
  const [avatar, setAvatar] = useState('')
  const [form] = Form.useForm()

  const getUserInfo = useCallback(() => {
    dispatch({
      type: 'center/getPersonalBasic',
    })
  }, [dispatch])

  const handleChangeAvatar = useCallback(() => {
    return new Promise((resolve) => {
      const avatarFile = form.getFieldValue('avatar')
      const formData = new FormData()
      formData.append('avatar', avatarFile.file)
      dispatch({
        type: 'center/updatePersonalAvatar',
        payload: {
          params: formData,
        },
      }).then(() => {
        resolve()
      })
    })
  }, [dispatch, form])

  const handleChangeUserInfo = useCallback(() => {
    return new Promise((resolve) => {
      const data = form.getFieldsValue()
      dispatch({
        type: 'center/updatePersonalProfile',
        payload: {
          params: {
            ...data,
          },
        },
      }).then(() => {
        resolve(true)
      })
    })
  }, [dispatch, form])

  const validateForm = () => {
    form
      .validateFields()
      .then(() => {
        const changeInfoPromise = handleChangeUserInfo()
        const requestTask = [changeInfoPromise]
        if (avatar) {
          const changeAvatarPromise = handleChangeAvatar()
          requestTask.push(changeAvatarPromise)
        }
        Promise.all([...requestTask]).then(() => {
          getUserInfo()
          dispatch({
            type: 'center/save',
            payload: {
              editBaseInfo: false,
            },
          })
          dispatch({
            type: 'global/getUserInfo',
          })
          form.resetFields()
          setAvatar('')
        })
      })
      .catch((errorInfo) => {
        console.log(errorInfo)
      })
  }

  const handleClickEditInfo = () => {
    if (editBaseInfo) {
      validateForm()
    } else {
      dispatch({
        type: 'center/save',
        payload: {
          editBaseInfo: !editBaseInfo,
        },
      })
      form.setFieldsValue({
        nickname: baseInfo.nickname,
        wechat: baseInfo.wechat,
        email: baseInfo.email,
        qq: baseInfo.qq,
        phone: baseInfo.phone,
        birthday: baseInfo.birthday,
        teamName: baseInfo.teamName,
      })
    }
  }

  const handleCancel = useCallback(() => {
    dispatch({
      type: 'center/save',
      payload: {
        editBaseInfo: !editBaseInfo,
      },
    })
    form.resetFields()
    setAvatar('')
  }, [dispatch, editBaseInfo, form])

  const getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('请选择JPG/PNG格式的图片')
      return
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('请选择小于2MB的图片')
      return
    }
    getBase64(file, (imageUrl) => {
      setAvatar(imageUrl)
    })
    // eslint-disable-next-line consistent-return
    return false
  }

  const validateAvatar = useCallback(
    (rules, value) => {
      if (!baseInfo.avatar && !value) {
        return Promise.reject('请上传头像')
      }
      return Promise.resolve()
    },
    [baseInfo]
  )

  return (
    <PageWrapper
      subTitle={
        <div styleName="query-box">
          <span styleName="title">基本信息</span>
          <div>
            {editBaseInfo && (
              <Button
                onClick={handleCancel}
                style={{ width: '88px', marginRight: '12px' }}
              >
                取消
              </Button>
            )}
            <Button
              onClick={handleClickEditInfo}
              style={{ width: '88px' }}
              type="primary"
            >
              {editBaseInfo ? '保存' : '编辑资料'}
            </Button>
          </div>
        </div>
      }
    >
      <Form
        {...layout}
        labelAlign="left"
        style={{ marginTop: '30px' }}
        name="baseinfo"
        requiredMark={false}
        form={form}
      >
        <Row>
          <Col span={12}>
            {editBaseInfo ? (
              <Form.Item
                label="头像"
                name="avatar"
                className="avatar"
                styleName="form-info"
                rules={[{ validator: validateAvatar }]}
                valuePropName="file"
              >
                <Upload
                  name="avatar"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                >
                  <img styleName="avatar" src={avatar || baseInfo.avatar} />
                  <span styleName="change-avatar">更换头像</span>
                </Upload>
              </Form.Item>
            ) : (
              <Form.Item
                label="头像"
                name="avatar"
                className="avatar"
                styleName="form-info"
              >
                <img styleName="avatar" src={baseInfo.avatar} />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              label="昵称"
              name="nickname"
              rules={[{ required: true, message: '请填写昵称' }]}
              styleName="form-info"
            >
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的昵称"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.nickname}</span>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="微信" name="wechat" styleName="form-info">
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的微信号"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.wechat || '--'}</span>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              label="邮箱"
              name="email"
              rules={[
                {
                  required: false,
                },
              ]}
              styleName="form-info"
            >
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的邮箱"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.email || '--'}</span>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="QQ" name="qq" styleName="form-info">
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的QQ号"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.qq || '--'}</span>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="生日" name="birthday" styleName="form-info">
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的生日"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.birthday || '--'}</span>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="电话"
              name="phone"
              rules={[
                {
                  required: baseInfo.isTeamLeader === 1,
                },
              ]}
              styleName="form-info"
            >
              {editBaseInfo ? (
                <Input
                  placeholder="请输入您的电话"
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.phone || '--'}</span>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="团队" name="teamName" styleName="form-info">
              {editBaseInfo ? (
                <Input
                  readOnly
                  placeholder={baseInfo.teamName || '无'}
                  style={{ width: '230px' }}
                />
              ) : (
                <span>{baseInfo.teamName || '无'}</span>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </PageWrapper>
  )
}

export default connect(({ center }) => {
  return {
    baseInfo: center.baseInfo,
    editBaseInfo: center.editBaseInfo,
  }
})(BaseInfo)
